module.exports = __webpack_public_path__ + "img/big5-7.37143493.jpg";